module.exports = __webpack_public_path__ + "img/86058270.dafd922e.png";